module.exports = __webpack_public_path__ + "static/media/GTVertical_TechGold.7e43317b.png";